'use client';
import { isPrimitive } from '../utils/isPrimitive.js';
import { assemble } from '../assemble/assemble.js';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
var strategyMonadic = function strategyMonadic(fn, options) {
    var _ref = options || {}, cache = _ref.cache, serializer = _ref.serializer;
    return assemble(fn, this, monadic, cache == null ? void 0 : cache.create(), serializer);
};

export { monadic, strategyMonadic };
